export default {
	workspace_drop_zone_hide: 'Dropzone verstecken',
	workspace_drop_zone_new_mail: 'Neue E-Mail',
	workspace_drop_zone_save_to_document_postbox: 'In Dokumentablage ablegen:',
	workspace_drop_zone_send_via_mail: 'Per Mail senden',
	workspace_drop_zone_send_via_mail_limit_message: 'Nur eine Datei per Drag-and-Drop',
	workspace_drop_zone_upload_failed_prefix: 'Upload fehlgeschlagen: ',
};
